// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__i2GlU","dark":"Faq_dark__aG9Gu","light":"Faq_light__HcwVw","image":"Faq_image__0vg80","text":"Faq_text__M6j9a","active":"Faq_active__6C4Fk"};